export { default as SimpleSelect } from "./SimpleSelect"
export { default as SimpleAsyncSelect } from "./SimpleAsyncSelect"

export type SelectOption = { value: string; label: string } & Record<
  string,
  any
>

export type DialingCodeSelectOption = {
  code: string
  dial_code: number
  flag: string
  name: string
} & Pick<SelectOption, "value" | "label">
